'use client';
import { useQuery } from '@tanstack/react-query';
import { useCallback, useState } from 'react';
import { useCurrentLocale } from '@peerless/ui-locale';
import { useDebouncedCallback } from 'use-debounce';
import { displaySearch } from '@peerless/data-access/next-api';
import { debounceTime, noResults } from './types';

export function useDisplaySearch() {
  const { locale } = useCurrentLocale();
  const [keyword, setKeyword] = useState('');

  const { data, isLoading } = useQuery({
    queryKey: ['Compatibility', 'Search', 'Displays', locale, keyword],
    queryFn: context =>
      displaySearch(
        { locale, keyword },
        {
          signal: context.signal,
        }
      ),
    enabled: !!keyword,
  });

  const search = useDebouncedCallback((keyword: string) => {
    setKeyword(keyword);
  }, debounceTime);

  const reset = useCallback(() => {
    setKeyword('');
  }, [setKeyword]);

  if (!data) {
    return {
      data: noResults(keyword),
      isLoading,
      search,
      reset,
    };
  }

  return {
    data: {
      ...data,
      products: data.products.map(({ text }) => ({
        title: text,
        sku: text,
        thumbnail: null,
      })),
    },
    isLoading,
    search,
    reset,
  };
}
